module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500italic.woff2?db4a2a231f52e497c0191e8966b0ee58";